import { Children, cloneElement, isValidElement } from 'react';

import parse from 'html-react-parser';

import { Typography } from '../Typography';
import {
    StyledRow,
    StyledCol,
    StyledSection,
    StyledTableWrapper,
} from './Grid.styled';
import {
    BoxProps,
    ColProps,
    RowProps,
    SectionProps,
    TableProps,
} from './types';

export {
    StyledContentWrapper as ContentWrapper,
    StyledSpacer as Spacer,
} from './Grid.styled';

export const Section = (props: SectionProps): JSX.Element => {
    const { noMargin, sectionTitle, children, ...rest } = props;

    return (
        <StyledSection {...rest} noMargin={noMargin}>
            {sectionTitle ? (
                <Typography variant="title.large" className="section-title">
                    {sectionTitle}
                </Typography>
            ) : undefined}
            {children}
        </StyledSection>
    );
};

export const Box = (props: BoxProps): JSX.Element => {
    const { children, ...rest } = props;

    return <div {...rest}>{children}</div>;
};

export const Col = (props: ColProps): JSX.Element => {
    const { children, ...rest } = props;

    return <StyledCol {...rest}>{children}</StyledCol>;
};

export const Row = (props: RowProps): JSX.Element => {
    const { children, ...rest } = props;

    return (
        <StyledRow {...rest} className="row">
            {Children.map(children, (child, i) => {
                if (isValidElement(child)) {
                    return (
                        <Col
                            key={`row_element_${i}`}
                            className="col"
                            {...child.props}
                        >
                            {cloneElement(child)}
                        </Col>
                    );
                }
                return null;
            })}
        </StyledRow>
    );
};

export const Table = (props: TableProps): JSX.Element => {
    const { children, ...rest } = props;

    const match =
        typeof children === 'string' && /<\/?[a-z][\s\S]*>/i.test(children);

    return (
        <StyledTableWrapper {...rest}>
            {match ? parse(children) : children}
        </StyledTableWrapper>
    );
};

export type {
    BoxProps,
    ColProps,
    SectionProps,
    RowProps,
    TableProps,
} from './types';
